import styled from "styled-components";

export const StyledSharedHint = styled.p`
    font-size: 10px;
    line-height: 20px;
    margin: 16px 0 0;
`;

export const StyledSectionName = styled.span`
    font-weight: bold;
`;

export const StyledSection = styled.p`
    font-size: 13px;
    line-height: 20px;
    margin: 0;

    &:not(:last-child) {
        margin-bottom: 16px;
    }
`;
